
<div class="slip-container">
  <h4>{{ merchantDetails.merchantName }}</h4>
  <table style="width: 100%; border: 0px solid silver;">
    <tr>

      <td class="test-width" colspan="1" style="border: 0px solid red; width: 180px; max-width: 180px;">
        <div class="info-row">
          <span class="mylabel">Merchant No:</span>
        </div>

        <div class="info-row">
          <span class="mylabel">Date Range:</span>
        </div>
        <div *ngFor="let item of transactionAmount">
          <div class="info-row">
            <span class="mylabel">{{ item.tranType }}</span>
          </div>
        </div>

      </td>

      <td class="test-width" colspan="1">
        <div class="info-row">
          <span class="section-title">{{ merchantDetails.merchantNumber }}</span>
        </div>

        <div class="info-row">
          <span class="section-title"> {{startDate}}  to  {{endDate}}</span>
        </div>
        <div *ngFor="let item of transactionAmount">
          <div class="info-row">
            <span class="section-title">R {{ item.amount}}</span>
          </div>
        </div>
      </td>
      <td style="text-align:center;border:0px solid red;padding:5px;width:200px;">
        <img src="../../../assets/images/altron_fintech_logo.png"
             alt="altron_fintech_logo" style="align-content:center;height:50px;width:150px" />
      </td>
    </tr>
  </table>
</div>
<hr />
